import styled from "styled-components";
import { color } from "../../styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

export const SortWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  height: 34px;
`;

export const BoxWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding-left: 12px;
  padding-right: 10px;
  border: 1px solid ${color.secondary.GREY_4};
  background-color: ${color.emphasis.NEUTRAL_N5};
  height: 34px;
  align-items: center;
  border-radius: 5px;

  &:hover {
    cursor: pointer;
    border-color: ${color.secondary.GREY_4};
  }
`;

export const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    width: 280px;
    padding: 8px 0px 10px 16px;
    display: flex;
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 5px;
    box-sizing: border-box;
  }
`;

export const CustomMenuItem = styled(MenuItem)`
  && {
    &:hover {
      background: none;
      color: ${color.primary.BLUE_B100};
    }
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 16px;
    padding: 5px 10px 5px 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Title = styled.div`
  font-size: 13px;
  font-weight: 500;
  line-height: 19px;
`;
